export { default as LatestModelUpdateCard } from './component';
